class ScrollbarMenu extends HTMLElement {
  connectedCallback() {
    this.drawer = document.getElementById("scrollbar-menu-drawer");
    this.overlay = document.getElementById("scrollbar-menu-overlay");
    this.inner = this.drawer.querySelector(".scrollbar-drawer__inner");
    this.menus = this.drawer.querySelectorAll(".scrollbar-drawer__menu");

    this.childGroups = this.drawer.querySelectorAll(
      ".scrollbar-menu-child__group"
    );

    this.overlay.addEventListener("click", () => this.closeDrawer());

    this.querySelectorAll(".menu-item__trigger").forEach((button) => {
      button.addEventListener("click", (e) => {
        const handle = e.currentTarget.dataset.parentHandle;
        this.openDrawer(handle);
        this.childGroups.forEach((g) => g.classList.remove("active"));
        const preview = document.querySelector(".scrollbar-menu-images");
        if (preview) preview.innerHTML = "";
      });
    });

    this.childGroups.forEach((group) => {
      group.querySelectorAll(".menu_link").forEach((item) => {
        item.addEventListener("mouseenter", (e) => this.showMenuImage(e));
        // item.addEventListener("mouseleave", () => this.hideMenuImage());
      });
    });

    // Childlink click handler
    this.drawer
      .querySelectorAll(".scrollbar-drawer__menu-item a")
      .forEach((item) => {
        item.addEventListener("click", (e) => this.handleChildClick(e));
      });
  }

  showMenuImage(e) {
    const parent = e.currentTarget.closest(
      ".menu_link, .menu_title, .scrollbar-menu-child__item"
    );
    if (!parent) return;

    const title = parent.dataset.title;
    const image = parent.dataset.image;

    const preview = document.querySelector(".scrollbar-menu-images");
    if (!preview) return;

    if (image) {
      preview.innerHTML = `
      <div class="scrollbar-menu-images__inner">
        <img src="${image}" alt="${title}">
        <div class="scrollbar-menu-images__title">${title}</div>
      </div>
    `;
    }
  }

  hideMenuImage() {
    const preview = document.querySelector(".scrollbar-menu-images");
    if (!preview) return;

    preview.innerHTML = "";
  }

  openDrawer(handle) {
    const menu = document.getElementById(`${handle}-scrollbar-drawer-menu`);
    if (!menu) return;

    // Remove all active triggers
    this.querySelectorAll(".menu-item__trigger").forEach((btn) =>
      btn.classList.remove("active")
    );

    // Add active to the clicked trigger
    const currentTrigger = this.querySelector(
      `.menu-item__trigger[data-parent-handle="${handle}"]`
    );
    if (currentTrigger) currentTrigger.classList.add("active");

    this.drawer.classList.add("scrollbar-drawer--open");
    this.overlay.classList.add("scrollbar-drawer__overlay--active");

    this.menus.forEach((m) =>
      m.classList.remove("scrollbar-drawer__menu--active")
    );
    menu.classList.add("scrollbar-drawer__menu--active");

    // reset child panel
    this.drawer.classList.remove("scrollbar-drawer--child-open");
  }

  handleChildClick(e) {
    const childTitle = e.currentTarget.textContent.trim();

    const matchGroup = [...this.childGroups].find(
      (g) => g.dataset.group === childTitle
    );

    // Không có group → redirect bình thường
    if (!matchGroup) return;

    // Có group → mở panel 2, không redirect
    e.preventDefault();

    this.childGroups.forEach((g) =>
      g.classList.toggle("active", g === matchGroup)
    );

    this.drawer.classList.add("scrollbar-drawer--child-open");
  }

  closeDrawer() {
    this.drawer.classList.remove("scrollbar-drawer--open");
    this.overlay.classList.remove("scrollbar-drawer__overlay--active");
    this.drawer.classList.remove("scrollbar-drawer--child-open");
    this.childGroups.forEach((g) => g.classList.remove("active"));
    this.querySelectorAll(".menu-item__trigger").forEach((btn) =>
      btn.classList.remove("active")
    );
    const preview = document.querySelector(".scrollbar-menu-images");
    if (preview) preview.innerHTML = "";
  }
}

customElements.define("scrollbar-menu", ScrollbarMenu);
